import { FullNamePipe } from '@abovo/shared-angular-utils';
import { ApprovalReviewer } from '@abovo/shared-models';
import { InitialsAvatarComponent } from '@abovo/shared-ui-components';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';
import { ReviewerRoleSlugs } from '../constants/approval-request.constants';

@Component({
   selector: 'webvis-feature-approval-feedback-reviewers-display',
   changeDetection: ChangeDetectionStrategy.OnPush,
   imports: [InitialsAvatarComponent, MatDivider, FullNamePipe, TranslatePipe],
   template: `
      <h3 class="mat-title-medium mb-2">{{ 'approval.assessors' | translate }}</h3>
      <div class="flex items-center gap-2 flex-wrap">
         @for (reviewer of requiredReviewers(); track reviewer.id) {
            <shared-ui-initials-avatar [name]="reviewer.user | fullName" />
         }
         @if (optionalReviewers().length) {
            <mat-divider
               [vertical]="true"
               class="h-12"
            />
            @for (reviewer of optionalReviewers(); track reviewer.id) {
               <shared-ui-initials-avatar [name]="reviewer.user | fullName" />
            }
         }
      </div>
   `,
})
export class ApprovalFeedbackReviewersDisplayComponent {
   readonly reviewers = input<ApprovalReviewer[]>([]);

   protected readonly requiredReviewers = computed(() => this.reviewers().filter((r) => r.role_type?.slug === ReviewerRoleSlugs.required));

   protected readonly optionalReviewers = computed(() => this.reviewers().filter((r) => r.role_type?.slug === ReviewerRoleSlugs.optional));
}
